module.exports = __webpack_public_path__ + "img/joinDotStraight4.0904c03b.svg";